import { Button, Modal } from '../../design-system/primitives/index.js'
import BottomSheet from '../../design-system/patterns/BottomSheet.jsx'
import { getKeepInventory } from '../../utils/guestKitchen.js'

function preferenceValue(inventory) {
  const names = inventory.profileNames || []
  if (names.length) return names.join(', ')
  return inventory.preferencesSaved ? 'Saved' : 'Not added'
}

function countLabel(count, singular, plural) {
  return `${count} ${count === 1 ? singular : plural}`
}

function DiscardContent({ kitchen, onConfirm, onCancel }) {
  const inventory = getKeepInventory(kitchen)
  return (
    <>
      <p id="discard-kitchen-description" className="discard-kitchen__lead">
        This kitchen can’t be added to an account that already exists.
      </p>
      <ul className="discard-kitchen__inventory">
        <li>
          <span>Pantry</span>
          <strong>{countLabel(inventory.pantryCount, 'item', 'items')}</strong>
        </li>
        <li>
          <span>Recipes</span>
          <strong>{inventory.recipeCount}</strong>
        </li>
        <li>
          <span>This week</span>
          <strong>{countLabel(inventory.plannedDinners, 'dinner', 'dinners')}</strong>
        </li>
        <li>
          <span>Preferences</span>
          <strong>{preferenceValue(inventory)}</strong>
        </li>
      </ul>
      <p className="discard-kitchen__note">
        To keep this kitchen, cancel and create a new account with an email that has not been used here.
      </p>
      <div className="discard-kitchen__actions">
        <Button variant="danger" onClick={onConfirm}>Discard and log in</Button>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
      </div>
    </>
  )
}

export default function DiscardKitchenConfirm({
  open,
  kitchen,
  mobile = false,
  onConfirm,
  onCancel,
}) {
  if (mobile) {
    return (
      <BottomSheet open={open} onClose={onCancel} className="discard-kitchen__sheet" aria-label="Discard this kitchen">
        <div className="discard-kitchen__mobile">
          <h2>Log in and discard this kitchen?</h2>
          <DiscardContent kitchen={kitchen} onConfirm={onConfirm} onCancel={onCancel} />
        </div>
      </BottomSheet>
    )
  }
  return (
    <Modal
      open={open}
      onClose={onCancel}
      titleId="discard-kitchen-title"
      describedById="discard-kitchen-description"
      contentClassName="discard-kitchen__modal"
    >
      <h2 id="discard-kitchen-title" className="pantry-confirm-title">
        Log in and discard this kitchen?
      </h2>
      <DiscardContent kitchen={kitchen} onConfirm={onConfirm} onCancel={onCancel} />
    </Modal>
  )
}
